var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('smartx-oms-trade-desk-wc',{attrs:{"parent-environment":_vm.clientEnv,"auth-token":_vm.authToken}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }